import Vue from 'vue'
import Vuex from 'vuex'
import VueLocalStorage from 'vue-localstorage';

import AuthStore from './modules/auth'
import MessagingStore from './modules/messaging'
import WhitelabelStore from './modules/whitelabel'
import NotificationsStore from './modules/notifications'

Vue.use(Vuex)
Vue.use(VueLocalStorage);

var auth_header

let PUBLISHER = 'publisher'
let ADMIN = 'admin'
let DEVELOPER = 'developer'

import { RepositoryFactory } from '../services/repositories/AuthAPI/RepositoryFactory'
const AuthRepo = RepositoryFactory.get('auth') 

export default new Vuex.Store({
  modules: {
    Auth: AuthStore,
    Messaging: MessagingStore,
    Whitelabel: WhitelabelStore,
    Notifications: NotificationsStore
  },
  state: {
    unreadNotificationsCount: 0,
    pwaInstallPrompt: null,
    isOnline: navigator.onLine
  },
  mutations: {
    setUnreadNotificationsCount(state, count) {
      state.unreadNotificationsCount = count
    },
    setPwaInstallPrompt(state, prompt) {
      state.pwaInstallPrompt = prompt
    },
    setOnlineStatus(state, status) {
      state.isOnline = status
    }
  },
  getters: {
    unreadNotificationsCount: state => state.unreadNotificationsCount,
    pwaInstallPrompt: state => state.pwaInstallPrompt,
    isOnline: state => state.isOnline
  }
})
